// Helpers para la plantilla de correo de ANIVERSARIO. Misma fuente que usa
// el backend en backend/services/emailTemplates.js: un solo archivo HTML con
// {{placeholders}}, frontend/public/assets/birthdaygifts/
// anniversary-email-template.html. Se usan acá para mostrar en el panel
// admin exactamente la tarjeta que se va a enviar, sin depender de
// Node/Puppeteer.

import { API_BASE_URL as API, urlDeArchivo } from "../config";

export const ANNIVERSARY_TEMPLATE_URL = "/assets/birthdaygifts/anniversary-email-template.html";
// Tamaño real de "Plantilla aniversario.png". Debe coincidir con el lienzo
// de la plantilla HTML y con ANNIVERSARY_CANVAS del backend.
export const ANNIVERSARY_TEMPLATE_CANVAS = { width: 1918, height: 1078 };

function escapeHtml(value = "") {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * Años cumplidos desde el ingreso. Misma regla que
 * `calcularAniosDeServicio` en el backend: si este año todavía no ha
 * llegado su fecha, cuenta uno menos.
 *
 * Se parte la cadena a mano en vez de usar `new Date("2019-03-10")`, que
 * interpreta la fecha como medianoche UTC y en Colombia la corre al día
 * anterior (ver utils/fechas.js).
 */
export function calcularAniosDeServicio(fechaIngreso) {
  if (!fechaIngreso) return null;
  const m = String(fechaIngreso).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;

  const ingreso = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  if (Number.isNaN(ingreso.getTime())) return null;

  const hoy = new Date();
  let anios = hoy.getFullYear() - ingreso.getFullYear();
  const yaPaso =
    hoy.getMonth() > ingreso.getMonth() ||
    (hoy.getMonth() === ingreso.getMonth() && hoy.getDate() >= ingreso.getDate());
  if (!yaPaso) anios -= 1;

  return anios >= 0 ? anios : null;
}

/**
 * Rellena la plantilla cruda con datos reales. A diferencia del backend
 * (que apunta el fondo a un archivo local para fotografiarlo con Puppeteer),
 * acá el fondo y la foto por defecto se resuelven a URLs absolutas del API,
 * para que se vean dentro de un <iframe srcDoc>.
 */
export function fillAnniversaryTemplate(rawHtml, fields = {}) {
  let html = rawHtml;

  const bgAbsoluteUrl = `${API}/assets/birthdaygifts/Plantilla%20aniversario.png`;
  html = html.split("url('Plantilla aniversario.png')").join(`url('${bgAbsoluteUrl}')`);

  const defaultPhoto = `${API}/assets/profileCover/DefaultProfile.jpg`;
  const values = {
    employeeName: escapeHtml(fields.employeeName || "Colaborador"),
    employeeArea: escapeHtml(fields.employeeArea || ""),
    employeeYears: escapeHtml(String(fields.employeeYears ?? "")),
    // urlDeArchivo convierte "/assets/profile/x.png" en una URL absoluta del
    // backend. Sin esto, dentro del <iframe srcDoc> (que no tiene origen
    // propio) una ruta relativa no resuelve contra nada y la foto sale rota
    // justo en la vista previa, aunque en el correo real se vea bien —el
    // backend ya la resuelve por su cuenta en resolveProfileImage().
    employeePhoto: urlDeArchivo((fields.employeePhoto || "").toString().trim()) || defaultPhoto,
  };
  for (const [key, value] of Object.entries(values)) {
    html = html.split(`{{${key}}}`).join(value);
  }
  html = html.replace("'/assets/profileCover/DefaultProfile.jpg'", `'${defaultPhoto}'`);

  return html;
}
